export default function waitTimeout(timeout = 500) {
    return new Promise(resolve => {
        setTimeout(resolve, timeout)
    })
}